import { selectors as authSelectors } from '@hixme/auth-ui'
import html from 'modules/notes/rules/htmlRules'

import { isKeyHotkey } from 'is-hotkey'

import {
  connectRequest,
  createRequest,
  getRequestByName,
} from 'modules/redux-gateway'
import notification from 'modules/app-core/notification-manager'
import { selectors as tagSelectors } from 'modules/tags'
import { actions, selectors, constants } from 'modules/notes'

import PostNote from '../components/PostNote'

const isBoldHotkey = isKeyHotkey('mod+b')
const isItalicHotkey = isKeyHotkey('mod+i')
const isUnderlinedHotkey = isKeyHotkey('mod+u')
const isCodeHotkey = isKeyHotkey('mod+`')

export default connectRequest({
  route: constants.NOTE_ALL_GET,
  onMount: ({ dispatch }) => {
    dispatch(actions.validatePostNote(true))
  },
  clearOnMount: true,
  onFailure: (request, dispatch) => {
    dispatch(
      notification.actions.createErrorNotification(
        'Sorry, there was an error adding a Note.'
      )
    )
  },
  mapStateToProps: (state, props) => {
    const editorValue = selectors.getPostNote(state) || constants.EMPTY_STATE
    const credentials = authSelectors.getCredentials(state)
    const noteReq = getRequestByName(state, constants.NOTE_ALL_GET)

    const setValue = (newValue) => {
      props.dispatch(actions.validatePostNote(!newValue.value.document.text))
      props.dispatch(actions.loadPostNote(newValue.value))
    }

    const clearPostNote = () => {
      props.onCancelPostNote(props)
      props.dispatch(actions.clearPostNote(constants.EMPTY_STATE))
    }

    const handleSubmit = () =>
      new Promise((resolve, reject) => {
        props.dispatch(actions.postingNote(true))
        // save note
        props
          .dispatch(
            createRequest({
              route: constants.NOTE_POST,
              body: {
                Id: props.note.ItemPublicKey,
                PersonPublicKey:
                  props.note.PersonPublicKey || noteReq.params.personPublicKey,
                AuthorPublicKey: credentials.personPublicKey,
                Body: html.serialize(editorValue),
              },
            })
          )
          .then(
            (response) => {
              props.dispatch(
                actions.loadNote(response, props.note.ItemPublicKey)
              )
              props.onPostedNote({
                ItemPublicKey: props.note.ItemPublicKey,
                ItemType: props.note.ItemType,
              })
              props.dispatch(actions.clearPostNote(constants.EMPTY_STATE))
              return resolve()
            },
            () => {
              clearPostNote()
              props.dispatch(
                notification.actions.createErrorNotification(
                  'Sorry, there was an error posting this Note.'
                )
              )
              props.dispatch(actions.postingNote(false))
              return reject()
            }
          )
      })

    const onKeyDown = (event, change) => {
      let mark

      if (isBoldHotkey(event)) {
        mark = 'bold'
      } else if (isItalicHotkey(event)) {
        mark = 'italic'
      } else if (isUnderlinedHotkey(event)) {
        mark = 'underlined'
      } else if (isCodeHotkey(event)) {
        mark = 'code'
      } else {
        return
      }

      event.preventDefault()
      change.toggleMark(mark)
    }

    const tags = tagSelectors.getTags(state, props.note.ItemPublicKey)

    const checkNoteErrors = () => {
      const errors = []
      if (selectors.getNoteError(state)) {
        errors.push('Note required')
      }
      if (!tags) {
        errors.push('At least one tag is required')
      }

      return errors
    }
    return {
      noteErrors: checkNoteErrors(),
      editorValue,
      setValue,
      handleSubmit,
      onKeyDown,
      onCancelNote: clearPostNote,
    }
  },
})(PostNote)
